export const calcMarginBasedOnYAxisValues = (yAxisValues: string[]) => {
  const BASE_VALUE = 3;
  const maxValueLength = Math.max(...yAxisValues.map((v) => v.length));
  return Math.max(0, maxValueLength - BASE_VALUE) * 5;
};
